import styled from 'styled-components';

const NewsItemsContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  min-height: max-content;
`;

const NewsItemsWrapper = styled.div`
  height: 100%;
  width: 90%;
  ul {
    padding-left: 40px;
    padding-top: 40px;
    li {
      p {
        color: #7c6d89;
        padding: 15px 0px;
        font-size: 16px;
      }
    }
  }
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  transform: translateY(-40px);
`;

export { NewsItemsContent, NewsItemsWrapper };
